export const DROP_INDICATOR = {
  height: 20,
  width: 20,
  padding: 5,
};
